import React from "react";
import ConnectedManualEmployerMatching from "../Pages/PaymentPage/ConnectedManualEmployerMatching";
import ConnectedEmployerMatching from "../Pages/PaymentPage/ConnectedEmployerMatching";

const EmployerMatchingControl = ({ controlId, isManualMatch }) => (
    <div className="grid">
        {isManualMatch ? (
            <ConnectedManualEmployerMatching controlId={controlId} />
        ) : (
            <ConnectedEmployerMatching controlId={controlId} />
        )}
    </div>
);

export default EmployerMatchingControl;
